import CSSLength from '../../../lib/css-property-parser/CSSLength';

/**
 * Helper wrapper, to allow utility operations on conversion result
 */
class ConvertedValue {
    constructor(value, unit) {
        this.unit = unit;
        this.value = value;
    }
    toString() {
        return Math.round(this.value) + this.unit;
    }
}

const options = {
    base: 16,
    formatter(value, unit) {
        return new ConvertedValue(value, unit);
    }
};

/**
 * Filters css length value, if originally was rems convert it back
 * @param oldValue
 * @param newValue
 * @returns {*}
 */
class RemFilter {
    constructor(oldValue) {
        if (oldValue === '0' || oldValue === 0) this.originalParsed = new CSSLength('0px', options);
        else this.originalParsed = new CSSLength(oldValue, options);
    }
    get original() {
        return this.originalParsed;
    }
    filter(newValue) {
        if (!newValue || this.originalParsed.unit === 'rem') {
            const converted = new CSSLength(newValue, options).rem;
            return converted.value + converted.unit;
        }
        return newValue;
    }
}

export { RemFilter };



// WEBPACK FOOTER //
// ./src/components/helpers/RemFilter.js